import { Loader } from '@crehana/compass.ui';
import { useIsClient } from '@crehana/react-hooks';
import Script from 'next/script';
import { NextSeo } from 'next-seo';

const TITLE = 'Crehana Jobs - Let’s make career development universal';
const DESCRIPTION =
  'We believe in a world where people can design their professional futures in collaboration with others. A world where skills can be accessed anytime, anywhere. A world where you can learn forever.';

const App = () => {
  const isClient = useIsClient();

  return (
    <>
      <NextSeo
        title={TITLE}
        description={DESCRIPTION}
        openGraph={{
          title: TITLE,
          description: DESCRIPTION,
          images: [
            {
              url: 'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/automated-v2-d41f7cb8-998f-4f78-be7f-6fcb3af6bd55-seo.jpg?auto=format',
              alt: 'Crehana Jobs',
            },
          ],
        }}
      />
      {/*
        This page had no getServerSideProps originally → it rendered client-side
        only. The route's dummy getServerSideProps now forces SSR (to drop the
        CORS-breaking `crossorigin` asset attr). The Greenhouse board mounts on
        the client (afterInteractive), so gate it behind useIsClient and show a
        loader during SSR/first paint. NextSeo stays outside the guard so the SEO
        meta is still server-rendered. Remove together with the route dummy once
        the CDN serves CORS headers for _next/static/*.
      */}
      {isClient ? (
        <>
          <div id="grnhse_app" />
          <Script
            key="greenhouse-script"
            strategy="afterInteractive"
            src="https://boards.greenhouse.io/embed/job_board/js?for=crehana"
          />
        </>
      ) : (
        <div className="flex h-screen w-screen items-center justify-center">
          <Loader />
        </div>
      )}
    </>
  );
};

export default App;
